module.exports = __webpack_public_path__ + "media/images/bar-81d00b1f772d24158ccb3ef9b2783c9d.svg";